import { render } from "./Coupon.vue?vue&type=template&id=6cb54d80&scoped=true"
import script from "./Coupon.vue?vue&type=script&lang=js"
export * from "./Coupon.vue?vue&type=script&lang=js"

import "./Coupon.vue?vue&type=style&index=0&id=6cb54d80&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6cb54d80"

export default script